const HOLIDAYS = {
  HALLOWEEN: 'HALLOWEEN',
  STAND_WITH_ISRAEL: 'STAND_WITH_ISRAEL',
  HAPPY_HOLIDAYS: 'HAPPY_HOLIDAYS',
};

export default HOLIDAYS;
